function isHTMLElement(value) {
  return value instanceof HTMLElement;
}
export {
  isHTMLElement
};
//# sourceMappingURL=isHTMLElement.js.map
